import {Doughnut} from "vue-chartjs"
import {mapGetters} from "vuex"
export default {
    name: 'OrderPaymentChart',
    extends: Doughnut,
    computed: Object.assign({}, mapGetters(['paypalOrders', 'cardOrders']), {
        chartData() {
            return {
                labels: ['PayPal', 'Credit Card'],
                data: [this.paypalOrders.length, this.cardOrders.length]
            }
        }
    }),
    mounted () {
        // Overwriting base render method with actual data.
        this.renderChart({
            labels: this.chartData.labels,
            datasets: [
                {
                    backgroundColor: ['#F15A5C', '#3273DC'],
                    data: this.chartData.data
                }
            ]
        }, {
            legend: {
                display: true,
                position: 'left',
            },
        })
    }
}


//////////////////
// WEBPACK FOOTER
// ./vue/src/components/charts/orderPaymentChart.js
// module id = 231
// module chunks = 0